/** Paths employees may use while account setup is incomplete (soft gate). */
export const ACCOUNT_SETUP_ALLOWED_PATHS = ['/profile', '/governance'] as const;

export function isAccountSetupAllowedPath(pathname: string): boolean {
  return ACCOUNT_SETUP_ALLOWED_PATHS.some(
    (allowed) => pathname === allowed || pathname.startsWith(`${allowed}/`),
  );
}

export interface ProfileSetupMissingItem {
  code: string;
  blocksAccess: boolean;
}

export interface ProfileSetupStatus {
  isExempt: boolean;
  isRestricted: boolean;
  missingItems: ProfileSetupMissingItem[];
}

export function normalizeProfileSetupStatus(data: {
  isExempt?: boolean;
  isRestricted?: boolean;
  missingItems?: Array<{ code?: string; blocksAccess?: boolean }>;
}): ProfileSetupStatus {
  return {
    isExempt: data.isExempt === true,
    isRestricted: data.isRestricted === true,
    missingItems: (data.missingItems ?? []).map((item) => ({
      code: item.code ?? '',
      blocksAccess: item.blocksAccess === true,
    })),
  };
}
